//import {launchTree} from './tree-menu/src';
import { createTree} from '@emilgadzhiyev/tree-menu' ;

export const launchTreeNova = () => {
  document.querySelectorAll("script.tree").forEach(createTree);
}
